import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';

import ForumItemScore from '../ForumItemScore';
import ForumItemInfo from '../ForumItemInfo';
import ForumItemToolbar from '../ForumItemToolbar';

const useStyles = makeStyles((theme) => ({
  info: {
    marginBottom: theme.spacing(1),
  },
}));

const ThreadAnswer = (props) => {
  const classes = useStyles();
  const {
    answer,
    loading,
    isLast,
    onDeleteAnswer,
    onEditAnswer,
    onReportAnswer,
    onUpvoteAnswer,
    onDownvoteAnswer,
  } = props;

  return (
    <Box width="100%" display="flex" mb={2}>
      <Box mr={2}>
        <ForumItemScore
          item={answer}
          score={answer?.score}
          onUpvote={onUpvoteAnswer}
          canUpvote={answer?.canUpvote}
          onDownvote={onDownvoteAnswer}
          canDownvote={answer?.canDownvote}
        />
      </Box>
      <Box flexGrow={1} mt={1}>
        <ForumItemInfo
          className={classes.info}
          createdAt={answer?.createdAt}
          user={answer?.user}
          loading={loading}
          edited={answer?.edited}
        />
        <div
          className="ck-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: answer?.content }}
        />
        <ForumItemToolbar
          loading={loading}
          item={answer}
          onDeleteItem={onDeleteAnswer}
          canDelete={answer?.canDelete}
          onReportItem={onReportAnswer}
          canReport={answer?.canReport}
          onEditItem={onEditAnswer}
          canEdit={answer?.canEdit}
          contentType="answer"
        />
        {!isLast && <Divider />}
      </Box>
    </Box>
  );
};

ThreadAnswer.propTypes = {
  loading: PropTypes.bool,
  answer: PropTypes.object,
  isLast: PropTypes.bool,

  onDeleteAnswer: PropTypes.func,
  onEditAnswer: PropTypes.func,
  onReportAnswer: PropTypes.func,
  onUpvoteAnswer: PropTypes.func,
  onDownvoteAnswer: PropTypes.func,
};

ThreadAnswer.defaultProps = {
  loading: false,
  isLast: false,
  answer: {},

  onDeleteAnswer() {},
  onEditAnswer() {},
  onReportAnswer() {},
  onUpvoteAnswer() {},
  onDownvoteAnswer() {},
};

export default ThreadAnswer;
